module.exports = __webpack_public_path__ + "static/phone-403abc17c411610b9c07a5d4d1f9634c.svg";